/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetVehiclesLiteParams,
  GetVehiclesParams,
  SearchVehicleResultPageDto,
  SearchVehiclesRequestDto,
  UpdateVehicleRequestDto,
  VehicleDetailDto,
  VehicleLitePageDto,
  VehiclePageDto
} from '../../models';

import { customInstance } from '../../../../custom-instance';
import type { ErrorType , BodyType } from '../../../../custom-instance';




/**
 * Returns the lean projection of the active vehicles belonging to one client. Sets the booking context to that client for the duration of the call. Returns an empty page — not 404 — for a blank or unknown client id. Requires the caller to be a fleet manager for the client.
 * @summary List a client's vehicles
 */
export const getVehiclesForClient = (
    clientId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehiclePageDto>(
      {url: `/fleet/vehicle/v1/clients/${clientId}/vehicles`, method: 'GET', signal
    },
      );
    }
  

export const getGetVehiclesForClientQueryKey = (clientId?: string,) => {
    return [`/fleet/vehicle/v1/clients/${clientId}/vehicles`] as const;
    }

    
export const getGetVehiclesForClientQueryOptions = <TData = Awaited<ReturnType<typeof getVehiclesForClient>>, TError = ErrorType<null | null | null>>(clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehiclesForClient>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVehiclesForClientQueryKey(clientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehiclesForClient>>> = ({ signal }) => getVehiclesForClient(clientId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVehiclesForClient>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehiclesForClientQueryResult = NonNullable<Awaited<ReturnType<typeof getVehiclesForClient>>>
export type GetVehiclesForClientQueryError = ErrorType<null | null | null>


export function useGetVehiclesForClient<TData = Awaited<ReturnType<typeof getVehiclesForClient>>, TError = ErrorType<null | null | null>>(
 clientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehiclesForClient>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehiclesForClient>>,
          TError,
          Awaited<ReturnType<typeof getVehiclesForClient>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehiclesForClient<TData = Awaited<ReturnType<typeof getVehiclesForClient>>, TError = ErrorType<null | null | null>>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehiclesForClient>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehiclesForClient>>,
          TError,
          Awaited<ReturnType<typeof getVehiclesForClient>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehiclesForClient<TData = Awaited<ReturnType<typeof getVehiclesForClient>>, TError = ErrorType<null | null | null>>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehiclesForClient>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a client's vehicles
 */

export function useGetVehiclesForClient<TData = Awaited<ReturnType<typeof getVehiclesForClient>>, TError = ErrorType<null | null | null>>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehiclesForClient>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVehiclesForClientQueryOptions(clientId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns the lean projection of the vehicles the authenticated user owns or manages, resolved from their token — no id has to be supplied. Returns an empty page rather than 404 when the user has none.
 * @summary List the calling user's vehicles
 */
export const getMyVehicles = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehiclePageDto>(
      {url: `/fleet/vehicle/v1/my-vehicles`, method: 'GET', signal
    },
      );
    }
  

export const getGetMyVehiclesQueryKey = () => {
    return [`/fleet/vehicle/v1/my-vehicles`] as const;
    }

    
export const getGetMyVehiclesQueryOptions = <TData = Awaited<ReturnType<typeof getMyVehicles>>, TError = ErrorType<null | null | null>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyVehicles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyVehiclesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyVehicles>>> = ({ signal }) => getMyVehicles(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyVehicles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyVehiclesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyVehicles>>>
export type GetMyVehiclesQueryError = ErrorType<null | null | null>


export function useGetMyVehicles<TData = Awaited<ReturnType<typeof getMyVehicles>>, TError = ErrorType<null | null | null>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyVehicles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyVehicles>>,
          TError,
          Awaited<ReturnType<typeof getMyVehicles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyVehicles<TData = Awaited<ReturnType<typeof getMyVehicles>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyVehicles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyVehicles>>,
          TError,
          Awaited<ReturnType<typeof getMyVehicles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyVehicles<TData = Awaited<ReturnType<typeof getMyVehicles>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyVehicles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the calling user's vehicles
 */

export function useGetMyVehicles<TData = Awaited<ReturnType<typeof getMyVehicles>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyVehicles>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyVehiclesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Searches the fleet with the given access mode and filter criteria and returns each match with its home and last position, the distance between them and its battery status. Access mode decides whose vehicles are in scope; the optional X-Client-Id header narrows the search to one client. Requires BattAdmin.
 * @summary Search vehicles
 */
export const searchVehicles = (
    searchVehiclesRequestDto: BodyType<SearchVehiclesRequestDto>,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SearchVehicleResultPageDto>(
      {url: `/fleet/vehicle/v1/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchVehiclesRequestDto, signal
    },
      );
    }
  


export const getSearchVehiclesMutationOptions = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchVehicles>>, TError,{data: BodyType<SearchVehiclesRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof searchVehicles>>, TError,{data: BodyType<SearchVehiclesRequestDto>}, TContext> => {

const mutationKey = ['searchVehicles'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchVehicles>>, {data: BodyType<SearchVehiclesRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  searchVehicles(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SearchVehiclesMutationResult = NonNullable<Awaited<ReturnType<typeof searchVehicles>>>
    export type SearchVehiclesMutationBody = BodyType<SearchVehiclesRequestDto>
    export type SearchVehiclesMutationError = ErrorType<null | null | null | null>

    /**
 * @summary Search vehicles
 */
export const useSearchVehicles = <TError = ErrorType<null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchVehicles>>, TError,{data: BodyType<SearchVehiclesRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchVehicles>>,
        TError,
        {data: BodyType<SearchVehiclesRequestDto>},
        TContext
      > => {

      const mutationOptions = getSearchVehiclesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns vehicles linked to a user identified by their remote ID. Designed for support agents who have already identified the caller via phone number lookup. Uses system-level authentication — no Keycloak token for the target user is required. Returns an empty page for an unknown remote id rather than 404. Requires BattAdmin.
 * @summary List a user's vehicles
 */
export const getVehiclesForUser = (
    userRemoteId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehiclePageDto>(
      {url: `/fleet/vehicle/v1/users/${userRemoteId}/vehicles`, method: 'GET', signal
    },
      );
    }
  

export const getGetVehiclesForUserQueryKey = (userRemoteId?: string,) => {
    return [`/fleet/vehicle/v1/users/${userRemoteId}/vehicles`] as const;
    }

    
export const getGetVehiclesForUserQueryOptions = <TData = Awaited<ReturnType<typeof getVehiclesForUser>>, TError = ErrorType<null | null | null | null>>(userRemoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehiclesForUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVehiclesForUserQueryKey(userRemoteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehiclesForUser>>> = ({ signal }) => getVehiclesForUser(userRemoteId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userRemoteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVehiclesForUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehiclesForUserQueryResult = NonNullable<Awaited<ReturnType<typeof getVehiclesForUser>>>
export type GetVehiclesForUserQueryError = ErrorType<null | null | null | null>


export function useGetVehiclesForUser<TData = Awaited<ReturnType<typeof getVehiclesForUser>>, TError = ErrorType<null | null | null | null>>(
 userRemoteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehiclesForUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehiclesForUser>>,
          TError,
          Awaited<ReturnType<typeof getVehiclesForUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehiclesForUser<TData = Awaited<ReturnType<typeof getVehiclesForUser>>, TError = ErrorType<null | null | null | null>>(
 userRemoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehiclesForUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehiclesForUser>>,
          TError,
          Awaited<ReturnType<typeof getVehiclesForUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehiclesForUser<TData = Awaited<ReturnType<typeof getVehiclesForUser>>, TError = ErrorType<null | null | null | null>>(
 userRemoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehiclesForUser>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a user's vehicles
 */

export function useGetVehiclesForUser<TData = Awaited<ReturnType<typeof getVehiclesForUser>>, TError = ErrorType<null | null | null | null>>(
 userRemoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehiclesForUser>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVehiclesForUserQueryOptions(userRemoteId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns the lean projection of every vehicle in the fleet, optionally restricted to the ones currently in service. Requires BattAdmin. Not cached — each call performs a fresh booking-engine read plus one batched model-info and one batched telematics lookup, so prefer the lite variant when only identity is needed.
 * @summary List fleet vehicles
 */
export const getVehicles = (
    params?: GetVehiclesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehiclePageDto>(
      {url: `/fleet/vehicle/v1/vehicles`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetVehiclesQueryKey = (params?: GetVehiclesParams,) => {
    return [`/fleet/vehicle/v1/vehicles`, ...(params ? [params]: [])] as const;
    }

    
export const getGetVehiclesQueryOptions = <TData = Awaited<ReturnType<typeof getVehicles>>, TError = ErrorType<null | null | null>>(params?: GetVehiclesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVehiclesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehicles>>> = ({ signal }) => getVehicles(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVehicles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehiclesQueryResult = NonNullable<Awaited<ReturnType<typeof getVehicles>>>
export type GetVehiclesQueryError = ErrorType<null | null | null>


export function useGetVehicles<TData = Awaited<ReturnType<typeof getVehicles>>, TError = ErrorType<null | null | null>>(
 params: undefined |  GetVehiclesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicles>>,
          TError,
          Awaited<ReturnType<typeof getVehicles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicles<TData = Awaited<ReturnType<typeof getVehicles>>, TError = ErrorType<null | null | null>>(
 params?: GetVehiclesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicles>>,
          TError,
          Awaited<ReturnType<typeof getVehicles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicles<TData = Awaited<ReturnType<typeof getVehicles>>, TError = ErrorType<null | null | null>>(
 params?: GetVehiclesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List fleet vehicles
 */

export function useGetVehicles<TData = Awaited<ReturnType<typeof getVehicles>>, TError = ErrorType<null | null | null>>(
 params?: GetVehiclesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicles>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVehiclesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns id, name, licence plate and owner for every vehicle — no telematics, no model info, no downstream fan-out. Use this to populate pickers and filters; use the full list endpoint when the extra fields are actually rendered. Requires BattAdmin.
 * @summary List fleet vehicles (identity only)
 */
export const getVehiclesLite = (
    params?: GetVehiclesLiteParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleLitePageDto>(
      {url: `/fleet/vehicle/v1/vehicles/lite`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetVehiclesLiteQueryKey = (params?: GetVehiclesLiteParams,) => {
    return [`/fleet/vehicle/v1/vehicles/lite`, ...(params ? [params]: [])] as const;
    }

    
export const getGetVehiclesLiteQueryOptions = <TData = Awaited<ReturnType<typeof getVehiclesLite>>, TError = ErrorType<null | null | null>>(params?: GetVehiclesLiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehiclesLite>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVehiclesLiteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehiclesLite>>> = ({ signal }) => getVehiclesLite(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVehiclesLite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehiclesLiteQueryResult = NonNullable<Awaited<ReturnType<typeof getVehiclesLite>>>
export type GetVehiclesLiteQueryError = ErrorType<null | null | null>


export function useGetVehiclesLite<TData = Awaited<ReturnType<typeof getVehiclesLite>>, TError = ErrorType<null | null | null>>(
 params: undefined |  GetVehiclesLiteParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehiclesLite>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehiclesLite>>,
          TError,
          Awaited<ReturnType<typeof getVehiclesLite>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehiclesLite<TData = Awaited<ReturnType<typeof getVehiclesLite>>, TError = ErrorType<null | null | null>>(
 params?: GetVehiclesLiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehiclesLite>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehiclesLite>>,
          TError,
          Awaited<ReturnType<typeof getVehiclesLite>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehiclesLite<TData = Awaited<ReturnType<typeof getVehiclesLite>>, TError = ErrorType<null | null | null>>(
 params?: GetVehiclesLiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehiclesLite>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List fleet vehicles (identity only)
 */

export function useGetVehiclesLite<TData = Awaited<ReturnType<typeof getVehiclesLite>>, TError = ErrorType<null | null | null>>(
 params?: GetVehiclesLiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehiclesLite>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVehiclesLiteQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns the complete projection of a single vehicle: everything the list endpoints return, plus description, day/hour/kilometre pricing, rental type, usage permissions, equipment and intent ids, the full technical specification block and the four fleet lifecycle dates. This is the shape the fleet vehicle-detail page renders from — a single call, no client-side merging. Performs one booking-engine read plus a model-info and a telematics lookup for this vehicle; not cached. Requires BattAdmin.
 * @summary Get one vehicle in full
 */
export const getVehicleById = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleDetailDto>(
      {url: `/fleet/vehicle/v1/vehicles/${vehicleId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetVehicleByIdQueryKey = (vehicleId?: string,) => {
    return [`/fleet/vehicle/v1/vehicles/${vehicleId}`] as const;
    }

    
export const getGetVehicleByIdQueryOptions = <TData = Awaited<ReturnType<typeof getVehicleById>>, TError = ErrorType<null | null | null | null>>(vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVehicleByIdQueryKey(vehicleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehicleById>>> = ({ signal }) => getVehicleById(vehicleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(vehicleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVehicleById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehicleByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getVehicleById>>>
export type GetVehicleByIdQueryError = ErrorType<null | null | null | null>


export function useGetVehicleById<TData = Awaited<ReturnType<typeof getVehicleById>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleById>>,
          TError,
          Awaited<ReturnType<typeof getVehicleById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleById<TData = Awaited<ReturnType<typeof getVehicleById>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleById>>,
          TError,
          Awaited<ReturnType<typeof getVehicleById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleById<TData = Awaited<ReturnType<typeof getVehicleById>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one vehicle in full
 */

export function useGetVehicleById<TData = Awaited<ReturnType<typeof getVehicleById>>, TError = ErrorType<null | null | null | null>>(
 vehicleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleById>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVehicleByIdQueryOptions(vehicleId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Applies the supplied changes to the vehicle and returns its complete projection — the same shape as the detail endpoint, so the caller does not need a follow-up read. Every field on the request is optional; the info fields use the updatable-field wrapper, so they can be left alone, set, or explicitly cleared. Requires BattAdmin.
 * @summary Update a vehicle
 */
export const updateVehicle = (
    vehicleId: string,
    updateVehicleRequestDto: BodyType<UpdateVehicleRequestDto>,
 ) => {
      
      
      return customInstance<VehicleDetailDto>(
      {url: `/fleet/vehicle/v1/vehicles/${vehicleId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateVehicleRequestDto
    },
      );
    }
  


export const getUpdateVehicleMutationOptions = <TError = ErrorType<null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicle>>, TError,{vehicleId: string;data: BodyType<UpdateVehicleRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVehicle>>, TError,{vehicleId: string;data: BodyType<UpdateVehicleRequestDto>}, TContext> => {

const mutationKey = ['updateVehicle'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVehicle>>, {vehicleId: string;data: BodyType<UpdateVehicleRequestDto>}> = (props) => {
          const {vehicleId,data} = props ?? {};

          return  updateVehicle(vehicleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof updateVehicle>>>
    export type UpdateVehicleMutationBody = BodyType<UpdateVehicleRequestDto>
    export type UpdateVehicleMutationError = ErrorType<null | null | null | null | null>

    /**
 * @summary Update a vehicle
 */
export const useUpdateVehicle = <TError = ErrorType<null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicle>>, TError,{vehicleId: string;data: BodyType<UpdateVehicleRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVehicle>>,
        TError,
        {vehicleId: string;data: BodyType<UpdateVehicleRequestDto>},
        TContext
      > => {

      const mutationOptions = getUpdateVehicleMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Retires the vehicle, and cannot be undone: stamps Out of fleet since (actualOutOfFleetDate) as now, sets the operational status to PHASED_OUT and cancels every booking that ends after now; rejected, expired and stopped bookings are already over and are left alone. Cancelled bookings are marked do-not-invoice, store the reason "vehicle phased out" and their bookers get a push notification, no e-mail. Every booking is checked before any is cancelled, so a refusal changes nothing. On success #ops is told the vehicle id and how many bookings were cancelled. Returns the vehicle's full projection, the same shape as the detail endpoint. No request body. BattAdmin only.
 * @summary Put a vehicle out of fleet
 */
export const putVehicleOutOfFleet = (
    vehicleId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleDetailDto>(
      {url: `/fleet/vehicle/v1/vehicles/${vehicleId}/actions/put-out-of-fleet`, method: 'POST', signal
    },
      );
    }
  


export const getPutVehicleOutOfFleetMutationOptions = <TError = ErrorType<null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVehicleOutOfFleet>>, TError,{vehicleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putVehicleOutOfFleet>>, TError,{vehicleId: string}, TContext> => {

const mutationKey = ['putVehicleOutOfFleet'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVehicleOutOfFleet>>, {vehicleId: string}> = (props) => {
          const {vehicleId} = props ?? {};

          return  putVehicleOutOfFleet(vehicleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutVehicleOutOfFleetMutationResult = NonNullable<Awaited<ReturnType<typeof putVehicleOutOfFleet>>>
    
    export type PutVehicleOutOfFleetMutationError = ErrorType<null | null | null | null | null>

    /**
 * @summary Put a vehicle out of fleet
 */
export const usePutVehicleOutOfFleet = <TError = ErrorType<null | null | null | null | null>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVehicleOutOfFleet>>, TError,{vehicleId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putVehicleOutOfFleet>>,
        TError,
        {vehicleId: string},
        TContext
      > => {

      const mutationOptions = getPutVehicleOutOfFleetMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    